import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog } from "@sveabank/cc-common";

type Props = {
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
	closeButtonText: string;
	handleAccept: () => void;
	acceptButtonText: string;
	title: string;
	description: React.ReactNode;
};

const ResetFlowWarningModal = ({
	isOpen,
	setOpen,
	closeButtonText,
	handleAccept,
	acceptButtonText,
	title,
	description,
}: Props) => (
	<Dialog isOpen={isOpen} setOpen={setOpen} size="small" center heading={title} icon="warning">
		<Dialog.Content>{description}</Dialog.Content>
		<ButtonGroup>
			<Button type="button" width="full" onPress={handleAccept}>
				{acceptButtonText}
			</Button>
			<Button
				type="button"
				width="full"
				variant="secondary"
				onPress={() => {
					setOpen(false);
				}}
			>
				{closeButtonText}
			</Button>
		</ButtonGroup>
	</Dialog>
);

export default ResetFlowWarningModal;
